// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import _ from 'lodash'
import { type OptionType } from '../types'
import Button from '../controls/PrimaryButton'
import type { LoadedAccount, ImportError } from '../AgencyPage'
import ErrorText from '../controls/ErrorText'
import AccountsImportListItem from './AccountsImportListItem'

const ListWrapper: StyledComponent<Object, any, any> = styled.div`
  padding-top: 10px;
`

export type ImportData = {|
  id: number,
  name: string,
  importType: string,
  selectedAccountId: number
|}

type Props = {|
  isLoading: boolean,
  accountOptions: Array<OptionType>,
  vkLoadedAccounts: Array<LoadedAccount>,
  reloadErrors: Array<string>,
  importErrors: Array<ImportError>,
  onImportAccounts: Function,
  onReloadAccounts: Function
|}

type State = {|
  importData: Array<ImportData>
|}

const t = {
  apply: 'Применить',
  reload: 'Загрузить список аккаунтов'
}

export default class AccountsImport extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      importData: []
    }
  }

  render() {
    const {
      isLoading,
      reloadErrors,
      importErrors,
      accountOptions,
      vkLoadedAccounts,
      onReloadAccounts,
      onImportAccounts
    } = this.props
    const { importData } = this.state
    return (
      <div>
        <Button disabled={isLoading} onClick={() => onReloadAccounts()}>
          {t.reload}
        </Button>
        {reloadErrors && <ErrorText errors={reloadErrors} />}
        <ListWrapper>
          {_.map(vkLoadedAccounts, (loadedAccount, index: number) => {
            const accountErrors = _.find(importErrors, (error) => {
              return loadedAccount.name === error.accountName
            })
            return (
              <div key={index}>
                <AccountsImportListItem
                  loadedAccount={loadedAccount}
                  accountOptions={accountOptions}
                  importData={importData}
                  onChange={(itemData) => {
                    const toRemove = _.find(importData, (data) => {
                      return _.isEqual(data.id, loadedAccount.id)
                    })
                    const newImportData = [
                      ..._.without(importData, toRemove),
                      { ...loadedAccount, ...itemData }
                    ]
                    this.setState({ importData: newImportData })
                  }}
                />
                <ErrorText errors={accountErrors && accountErrors.errors} />
              </div>
            )
          })}
        </ListWrapper>
        <Button onClick={() => onImportAccounts(importData)}>{t.apply}</Button>
      </div>
    )
  }
}
